import http from '../../../service/axios';
import { ensureMindboxDeviceUUID } from '../../../lib/mindbox';
import {
  IOtpAuthResponse,
  IRegisterClient,
  IRegisterData,
  ISendOtpData,
  ISignIn,
  IVerifyOtp,
  IVerifyOtpData,
} from '../types/Auth';

export const authAPI = {
  // Вход по Telegram остаётся на старом API: в client/otp-auth телеграмных
  // эндпоинтов нет вовсе, а автологин в мини-аппе держится именно на нём.
  signIn: async (body: ISignIn) =>
    await http.post(
      'user/login-with-tg',
      {
        initData: body,
      },
      {
        params: {
          deviceUUID: await ensureMindboxDeviceUUID(),
        },
      }
    ),
};

/**
 * Конфиг запросов `client/otp-auth`.
 *
 * Content-Type задаём явно: перехватчик axios подставляет `multipart/form-data`
 * всему, у чего заголовка нет, а этот модуль принимает только JSON.
 * `Language` — язык текстов в ответе, включая сообщения об ошибках; свой
 * словарь под них поэтому не нужен.
 * `Device-Id` — deviceUUID для Mindbox: на verify-otp/register бэкенд зовёт
 * Online.Authorization, и без UUID Mindbox пишет «DeviceUUID is missing».
 */
const otpAuthConfig = async () => ({
  headers: {
    'Content-Type': 'application/json',
    Language: localStorage.getItem('language') || 'ru',
    'Device-Id': await ensureMindboxDeviceUUID(),
  },
});

export const otpAuthAPI = {
  sendOtp: async (phone: string) =>
    await http.post<IOtpAuthResponse<ISendOtpData>>(
      'otp-auth/send-otp',
      { phone },
      await otpAuthConfig()
    ),
  verifyOtp: async (body: IVerifyOtp) =>
    await http.post<IOtpAuthResponse<IVerifyOtpData>>(
      'otp-auth/verify-otp',
      body,
      await otpAuthConfig()
    ),
  register: async (body: IRegisterClient) =>
    await http.post<IOtpAuthResponse<IRegisterData>>(
      'otp-auth/register',
      body,
      await otpAuthConfig()
    ),
};
